<template>
  <footer>
    <div class="container text-center text-md-left">
      <div class="row">
        <div class="col footer-block">
          <div class="footline">
            <a href="/" style="vertical-align: text-bottom">
              <img src="@/assets/logo.svg" alt />
            </a>
          </div>
        </div>
        <div class="col-md-3 text-center footer-block">
          <div class="footline">
            <a href="https://vikingo.org/engine/docs/about"> Docs </a>
            |
            <a href="javascript:;" @click="showAbout = true"> About </a>
          </div>
        </div>

        <div class="col footer-block">
          <div class="copyright">
            <span>© 2025 Vikingo Engine</span>
            <br />
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="About" :visible.sync="showAbout" class="modalSave">
      Vikingo TM ({{ version }})</el-dialog
    >
  </footer>
</template>
<script>
import { getAbout } from "@/api.js";
export default {
  created() {
    getAbout().then((data) => {
      this.version = data.Version;
    });
  },
  data() {
    return {
      showAbout: false,
      version: "",
      build: "",
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue